<template>
  <ul class="eventHospitalsLists">
    <li v-for="hospital in hospitals" :key="hospital.hospital_id">
      <div
        :class="{
          eventHospitalsLists_content: isArchivedHospitalMovie(hospital.movie)
        }"
      >
        <component
          :is="convertToTag(hospital.is_organization_offline)"
          :to="
            convertToLink(
              hospital.is_organization_offline,
              hospital.hospital_id
            )
          "
        >
          <div>
            <div class="eventHospitalsLists_tags">
              <p v-for="type in hospital.type" :key="type">
                {{ type }}
              </p>
              <p class="region">{{ hospital.region }}</p>
            </div>
            <div class="eventHospitalsLists_inner">
              <p>{{ hospital.name }}</p>
              <span class="eventHospitalsLists_detail">病院詳細</span>
            </div>
          </div>
        </component>

        <div
          class="eventHospitalsLists_buttonWrapper"
          v-if="isArchivedHospitalMovie(hospital.movie)"
        >
          <Button
            class="eventHospitalsLists_button"
            label="視聴する"
            primary
            @click="openModal(hospital.movie, hospital.name)"
          />
        </div>
      </div>
    </li>
  </ul>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue'
import Button from '@/components/elements/Button.vue'
import {
  EventDetailHospitalContent,
  EventDetailHospitalMovie
} from '@/types/EventDetail'
export default defineComponent({
  name: 'EventDetailHospitalList',
  components: {
    Button
  },
  props: {
    hospitals: {
      type: Array as PropType<EventDetailHospitalContent[]>,
      default: () => [],
      required: true
    },
    isArchived: {
      type: Boolean,
      default: false,
      required: true
    },
    openModal: {
      type: Function as PropType<
        (movies: EventDetailHospitalMovie[], title: string) => void
      >,
      required: true
    }
  },
  setup(props) {
    const convertToTag = (offline: string): string =>
      offline ? 'div' : 'router-link'
    const convertToLink = (offline: string, id: string): string | null =>
      offline ? null : `/search/hospital/detail/${id}`
    const isArchivedHospitalMovie = (movie: EventDetailHospitalMovie[]) => {
      return (
        props.isArchived &&
        movie &&
        !!movie.filter((m) => m.label.includes('video')).length
      )
    }

    return {
      convertToTag,
      convertToLink,
      isArchivedHospitalMovie
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
.eventHospitalsLists {
  line-height: 1.3;
  > li {
    padding-top: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid var.$color-border-gray;
  }
}

.eventHospitalsLists_content {
  display: grid;
  gap: 10px;
  grid-template:
    'link button'
    / 1fr 100px;
  @include mixins.media() {
    grid-template:
      'link button'
      / 1fr 160px;
  }
}
.eventHospitalsLists_buttonWrapper {
  display: flex;
  align-items: center;
}
::v-deep .eventHospitalsLists_button {
  min-height: 40px;
  max-height: 40px;
}

.eventHospitalsLists_tags {
  display: flex;
  flex-wrap: wrap;
  font-size: 1rem;
  margin: -4px -4px 0;
  padding-right: 90px;

  > p {
    margin: 4px;
    min-width: 64px;
    line-height: 18px;
    text-align: center;
    background-color: var.$color-secondary;

    &.region {
      border: none;
      background-color: #fffccb;
      color: inherit;
    }
  }
}
.eventHospitalsLists_inner {
  display: flex;
  width: 100%;
  align-items: center;
}
.eventHospitalsLists_detail {
  position: relative;
  font-size: 1.4rem;
  font-weight: 500;
  color: var.$color-main;
  padding-right: 20px;
  margin-left: auto;
  margin-right: 0;
  flex: 0 0 90px;
  padding-left: 8px;
  &::after {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-42%);
    content: '';
    display: block;
    width: 7px;
    height: 11px;
    background-image: url('~@/assets/icon/arrow-right-main.svg');
    background-size: contain;
    background-repeat: no-repeat;
  }
}
</style>
